module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/AIR_ELEMENTAL_STYLE.6ef6210e.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/AIR_ELEMENTAL_STYLE.png
// module id = 1138
// module chunks = 16